<template>

<div id="table-scroll" class="table-scroll">
  <table id="main-table" class="main-table">
    <thead>
      <tr>
        <th scope="col">TEAM</th>
        <th scope="col">GP/GS</th>
        <th scope="col">ATT</th>
        <th scope="col">COMP</th>
        <th scope="col">YDS</th>
        <th scope="col">COMP%</th>
        <th scope="col">TD</th>
        <th scope="col">INT</th>
        <th scope="col">RATING</th>
        <th scope="col">RECORD</th>
        <th scope="col">SKS</th>
        <th scope="col">YDS</th>
                

      </tr>
    </thead>
    <tbody>
      <tr v-for="team in breesvsteams">
        <th v-bind:style="{ backgroundImage: 'url(https://static.www.nfl.com/t_q-best/league/api/clubs/logos/' + team.ABRV }">{{team.OPPONENT}}</th>
        <td>{{team.GPGS}}</td>
        <td>{{team.ATT}}</td>
        <td>{{team.COMP}}</td>
        <td>{{team.YARDS}}</td>
        <td>{{team.COMPPER}}</td>
        <td>{{team.TD}}</td>
        <td>{{team.INT}}</td>
        <td>{{team.RATING}}</td>
        <td>{{team.RECORD}}</td>
        <td>{{team.SKS}}</td>
        <td>{{team.YDS}}</td>
      </tr>
     
    </tbody>
  </table>

</div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'StickyStatTable',
  data: function () {
    return {
breesvsteams: []
  }
  },
  methods: {

  },
  mounted(){
 
 axios.get('../../static/brees-vs-teams.json').then(response => (
        this.breesvsteams = response.data,
        console.log(this.breesvsteams, "Mounted returns the breesvsteams")
        ))

}
}

</script>

<style>

html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
.intro {
  max-width: 1280px;
  margin: 1em auto;
}
.table-scroll {
  position: relative;
  width:100%;
  z-index: 1;
  margin: auto;
  overflow: scroll;
  height: 350px;
}
.table-scroll table {
  width: 100%;
  min-width: 1280px;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0;
}
.table-wrap {
  position: relative;

}
.table-scroll th,
.table-scroll td {
  padding: 5px 10px;
  border: 1px solid #000;
  background: #fff;
  vertical-align: top;
  font-family: 'Poppins', sans-serif;
      padding-right: 5px;
}




.table-scroll thead th {
  background: #333;
  color: #fff;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
/* safari and ios need the tfoot itself to be position:sticky also */
.table-scroll tfoot,
.table-scroll tfoot th,
.table-scroll tfoot td {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  background: #666;
  color: #fff;
  z-index:4;
}



th:first-child {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 2;
  background: #fff;
  font-size: 12px;
  text-align: right;
  background-image: url(https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/DET.svg);
  background-position: -9px -30px;
  background-size: 55%;
  background-repeat: no-repeat;
  vertical-align: middle;

}
thead th:first-child,
tfoot th:first-child {
  z-index: 5;
      font-size: initial;
    padding-right: 10px;
}

@media (min-width:1275px) {
th:first-child {
    background-position: -9px -45px;
    background-size: 50%;
}
}


</style>


// WEBPACK FOOTER //
// src/components/StickyStatTable.vue